import { render } from "./PricingActionModal.vue?vue&type=template&id=1ff2301e&scoped=true"
import script from "./PricingActionModal.vue?vue&type=script&lang=js"
export * from "./PricingActionModal.vue?vue&type=script&lang=js"

import "./PricingActionModal.vue?vue&type=style&index=0&id=1ff2301e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff2301e"]])

export default __exports__